// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"a8d5681c","765":"276780bf"}[chunkId] + ".chunk.css";
};